import { Suspense, lazy } from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Finish, Login as TypewriterLogin } from './modules/Typewriter';
import {
  Login,
  ProcessFinish,
  StudentLogin,
  LoginBindPosition,
  StudentBindPosition,
} from './modules/Login';
import BookingUrl from './pages/BookingUrl';
import {
  AISimulateList,
  AISimulate,
  AIReport,
  AIEnterpriseSimulateList,
} from './modules/Interview';
import Language from './Language';
import PortraitRouters from './platform/portrait/Router';

function App() {
  const Home = lazy(() => import('./pages/Home'));
  const OSSLogin = lazy(() => import('./pages/oss/Login'));
  const Interview = lazy(() => import('./pages/Interview'));
  const Room = lazy(() => import('./pages/Room'));
  const Typewriter = lazy(() => import('./pages/Typewriter'));
  const IdentityVerify = lazy(() => import('./pages/process/IdentityVerify'));
  const ConfirmAuth = lazy(() => import('./pages/process/ConfirmAuth'));
  const FaceVerify = lazy(() => import('./pages/process/FaceVerify'));
  const AuthResult = lazy(() => import('./pages/process/AuthResult'));
  return (
    <Suspense fallback={null}>
      <Router>
        <Language>
          <Routes>
            <Route path="/" element={<Home />} />
            {PortraitRouters()}
            <Route path="/oss/login" element={<OSSLogin />} />
            <Route path="/interview/ai/:token" element={<Interview />} />
            <Route path="/c/:roomToken" element={<Room />} />
            <Route
              path="/t/:applicationToken/:interviewToken/:articleToken/:mode"
              element={<Typewriter />}
            />
            <Route path="/t/finish" element={<Finish />} />
            <Route
              path="/t/login/:applicationToken/:interviewToken"
              element={<TypewriterLogin />}
            />
            <Route path="/login" element={<Login />} />
            <Route path="/studentlogin" element={<StudentLogin />} />
            <Route
              path="/login/:interviewToken"
              element={<LoginBindPosition />}
            />
            <Route
              path="/studentlogin/:interviewToken"
              element={<StudentBindPosition />}
            />
            <Route
              path="/process/:applicationToken"
              element={<ProcessFinish />}
            />
            <Route
              path="/process/:applicationToken/:token/idverify"
              element={<IdentityVerify />}
            />
            <Route
              path="/process/:applicationToken/:token/idverify/confirm"
              element={<ConfirmAuth />}
            />
            <Route
              path="/process/:applicationToken/:token/idverify/face"
              element={<FaceVerify />}
            />
            <Route
              path="/process/:applicationToken/:token/idverify/result"
              element={<AuthResult />}
            />
            <Route
              path="/enterprise/simulate/:token/:only"
              element={<AIEnterpriseSimulateList />}
            />
            <Route path="/simulate/:type" element={<AISimulateList />} />
            <Route path="/simulate/:type/:token" element={<AISimulate />} />
            <Route path="/report/:type/:token" element={<AIReport />} />
            <Route path="/booking/:token" element={<BookingUrl />} />
          </Routes>
        </Language>
      </Router>
    </Suspense>
  );
}

export default App;
